// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fd55ca845--container--nj4Cq","text":"_0fd55ca845--text--Itx_C"};